import { Injectable } from "@angular/core";
import { FgiBackEndService } from "../fgi-back-end.service";
import { TaxaJurosMediaMaximaAgente } from "src/app/model/taxa-juros-media-maxima-agente.model";
import { Observable } from "rxjs";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TaxaJurosMediaMaximaAgenteService extends FgiBackEndService<any>{
  // @Override
  getNewEntity() {
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return undefined;
  }

  public buscarTaxaMediaMaxima(ideTranche: number, params?: any): Observable<TaxaJurosMediaMaximaAgente[]> {
    let options: any = blockUi();
    return this.http.get('rest/front/taxa-juros-media-maxima-agente/tranche/' + ideTranche, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<TaxaJurosMediaMaximaAgente[]>;
  }
}